export { default } from './Confirm';



// WEBPACK FOOTER //
// ./src/lauoyts/Common/Confirm/index.js